"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DbSupportedLanguageSchema = exports.SupportedLanguageSchema = void 0;
const zod_1 = require("zod");
/**
 * @deprecated use DbSupportedLanguageSchema instead
 */
exports.SupportedLanguageSchema = zod_1.z.enum(['nl', 'en', 'fr']);
exports.DbSupportedLanguageSchema = zod_1.z.enum(['nl', 'en', 'fr']);
//# sourceMappingURL=shared.supported-language.js.map